<template>
  <div class="liu" v-wechat-title="'解锁账户'">
    <!-- 顶部提示信息 -->
    <div class="tips page-padding-l-r">
      <span class="txt">{{ finalTopTips }} <span class="red">{{ formData.failMsg }}</span></span>
    </div>
    <!-- 身份证：照片+信息 -->
    <div v-if="param.isNeedIdCard" class="color-f-bg">
      <!-- 照片区 -->
      <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r color-f-bg">
        <!-- Label-->
        <div style="width: 95px;">
          <span>证件照</span>
        </div>
        <!-- 头像页 -->
        <div class="align-center title-5 say-color" style="margin-right: 0.5rem;">
          <div class="id-card-style" @click="cameraImgClick('renXiang')">
            <img v-if="renXiang.webUrl" class="img" :src="renXiang.webUrl" />
            <svg-icon v-else class-name="img" icon-class="authenticate-headshot"></svg-icon>
          </div>
          <div class="icon-card-tips">头像页</div>
        </div>
        <!-- 国徽页 -->
        <div class="align-center title-5 say-color">
          <div class="id-card-style" @click="cameraImgClick('guoHui')">
            <img v-if="guoHui.webUrl" class="img" :src="guoHui.webUrl" />
            <svg-icon v-else class-name="img" icon-class="authenticate-emblem"></svg-icon>
          </div>
          <div class="icon-card-tips">国徽页</div>
        </div>
      </div>
      <!-- 身份信息 -->
      <!-- 姓名 -->
      <div v-if="renXiang.webUrl" class="margin-l-15">
        <div class="line" />
        <div class="flex-s form-item">
          <div style="width: 95px;">姓名</div>
          <input type="tel" class="flex-1" placeholder="请输入姓名" v-model.trim="formData.idCardName" />
        </div>
      </div>
      <!-- 身份证号 -->
      <div v-if="renXiang.webUrl" class="margin-l-15">
        <div class="line" />
        <div class="flex-s form-item">
          <div style="width: 95px;">身份证号</div>
          <input type="tel" class="flex-1" placeholder="请输入身份证号" v-model.trim="formData.idCardNum" disabled />
        </div>
      </div>
      <!-- 有效期 -->
      <div v-if="guoHui.webUrl" class="margin-l-15">
        <div class="line" />
        <div class="flex-s form-item">
          <div style="width: 95px;">有效期</div>
          <input type="tel" class="flex-1" placeholder="请输入有效期" v-model.trim="formData.dateOf" disabled />
        </div>
      </div>
    </div>
    <!-- 活体 + 手持 -->
    <div v-if="param.isActive" class="color-f-bg">
      <!-- 横线 -->
      <div v-if="param.isNeedIdCard" class="line" />
      <!-- 活体 -->
      <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r">
        <div style="width: 95px;">人脸识别</div>
        <div class="faceStyle" @click="cameraImgClick('renLian')">
          <img v-if="renLian.webUrl" class="img" :src="renLian.webUrl" />
          <svg-icon v-else class-name="img" icon-class="camera_face" />
        </div>
      </div>
      <!-- 横线 -->
      <div class="line" />
      <!-- 手持身份证 -->
      <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r color-f-bg">
        <div style="width: 95px;">
          <div>手持身份</div>
          <div>证正面照</div>
        </div>
        <div class="handFaceStyle" @click="cameraImgClick('shouChi')">
          <img class="img" :src="shouChi.webUrl || require('@/assets/handheld_example@3x.png')" />
        </div>
      </div>
      <!-- 提示信息 -->
      <div class="flex padding-t-10 padding-b-10 page-padding-l-r title-6 say-color">
        <div class="flex-1 say-color">
          避免证件与头部重叠，身份证证件内容要清晰可见，完全露出双手手臂
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" :disabled="submitDisabled" @click="onSubmitClick">{{ sbumitText }}</mt-button>
    </div>
    <!-- 百度活体识别弹出框组件 -->
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
  </div>
</template>

<script>
/* global PUBLIC_FACE_PHOTO_TIPS */
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import Liveness from '@/components/Liveness';
import { mapGetters, mapMutations } from 'vuex';
import { formatDateLongStr } from '@/utils/utils.js';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { GetIdCardFrontUrlV2, GetIdCardBackUrlV2, YMTivingThing, SubmitSleepUserData } from '@/api/weChat.js';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'SleepUserWakeUp',
  components: { SvgIcon, Liveness },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        success: false,
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        success: false,
      },
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
        popupVisible: false,
        photoTips: PUBLIC_FACE_PHOTO_TIPS,
      },
      // 云码通人脸识别
      ymt: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 表单数据
      formData: {
        idCardName: '',
        idCardNum: '',
        address: '',
        familyName: '',
        birthday: '',
        sex: '',
        office: '',
        dateOfIssue: '',
        dateOfInvalid: '',
        dateOf: '',
        failMsg: '',
      },
      // url参数
      param: {
        sleepCode: 0,
        faceDetectActivity: 0, // 活体认证类型
        idCardBatchNo: '', // 身份证识别批次号 2023.4.23
        isNeedIdCard: 1, // 2024.11.18 身份证标识
        isActive: 1, // 2024.11.18 人脸手持标识
        isMerPic: 1, // 2024.11.18 商户照片标识
      },
      // 百度人脸弹窗开关
      livingFacePopupVisible: false,
      // 顶部提示信息文字
      topTips: '身份认证照片',
    };
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus']),
    submitDisabled() {
      // 当身份证和人脸都需要
      if (this.param.isNeedIdCard && this.param.isActive) {
        return !this.renXiang.webUrl || !this.guoHui.webUrl || !this.renLian.webUrl || !this.shouChi.webUrl;
      }
      // 当只需要身份证，不需要人脸
      if (this.param.isNeedIdCard && !this.param.isActive) {
        return !this.renXiang.webUrl || !this.guoHui.webUrl;
      }
      // 当不需要身份证，只需要人脸
      if (!this.param.isNeedIdCard && this.param.isActive) {
        return !this.renLian.webUrl || !this.shouChi.webUrl;
      }
    },
    sbumitText() {
      // 如果需要商户照片，则返回下一步，反之，则返回提交
      if (this.param.isMerPic) return '下一步';
      return '提交';
    },
    finalTopTips() {
      return this.param.isNeedIdCard ? '身份认证照片' : '人脸信息';
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.param.sleepCode = parseInt(this.$route.query.sleepcode);
      this.param.faceDetectActivity = parseInt(this.$route.query.facedetectactivity);
      this.param.idCardBatchNo = `${formatDateLongStr(new Date())}${String(Math.floor(Math.random() * 9000000000000 + 1000000000000))}`;
      this.param.isNeedIdCard = this.$route.query.isneedidcard ? parseInt(this.$route.query.isneedidcard) : 0;
      this.param.isActive = this.$route.query.isactive ? parseInt(this.$route.query.isactive) : 0;
      this.param.isMerPic = this.$route.query.ismerpic ? parseInt(this.$route.query.ismerpic) : 0;
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.param.idCardBatchNo = this.$route.query.idcardbatchno;
        this.formData.idCardName = this.$route.query.idcardname;
        this.formData.idCardNum = this.$route.query.idcardnum;
        this.formData.dateOfIssue = this.$route.query.dateofissue;
        this.formData.dateOfInvalid = this.$route.query.dateofinvalid;
        this.formData.dateOf = `${this.$route.query.dateofissue} - ${this.$route.query.dateofinvalid}`;
        this.formData.failMsg = this.$route.query.failmsg;
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburl).replace('|', '?');
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburl).replace('|', '?');
        this.renLian.webUrl = decodeURIComponent(this.$route.query.rlweburl).replace('|', '?');
        this.shouChi.webUrl = decodeURIComponent(this.$route.query.scweburl).replace('|', '?');
        switch (imgType) {
          case 'renXiang':
            this.getIdCardFrontUrlV2();
            break;
          case 'guoHui':
            this.getIdCardBackUrlV2();
            break;
          case 'ymt':
            this.yMTivingThing();
            break;
          case 'renLian':
          case 'shouChi':
            break;
        }
      } else {
        if (this.$route.query.code) {
          this.formData.idCardName = this.$route.query.idcardname || '';
          this.formData.idCardNum = this.$route.query.idcardnum || '';
          this.formData.dateOfIssue = this.$route.query.dateofissue || '';
          this.formData.dateOfInvalid = this.$route.query.dateofinvalid || '';
          this.formData.dateOf = this.$route.query.dateofissue && this.$route.query.dateofinvalid ? `${this.$route.query.dateofissue} - ${this.$route.query.dateofinvalid}` : '';
          this.formData.failMsg = this.$route.query.failmsg || '';
          this.renXiang.webUrl = this.$route.query.rxweburl ? decodeURIComponent(this.$route.query.rxweburl).replace('|', '?') : '';
          this.guoHui.webUrl = this.$route.query.ghweburl ? decodeURIComponent(this.$route.query.ghweburl).replace('|', '?') : '';
          this.renLian.webUrl = this.$route.query.rlweburl ? decodeURIComponent(this.$route.query.rlweburl).replace('|', '?') : '';
          this.shouChi.webUrl = this.$route.query.scweburl ? decodeURIComponent(this.$route.query.scweburl).replace('|', '?') : '';
        }
      }
    });
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 提交数据
    onSubmitClick() {
      // 2024.11.18 添加 判断商户照片标识
      if (this.param.isMerPic) {
        // 如果有商户照片标识，则跳转商户添加照片页面
        const data = {
          page: 'wakeup',
          idcardName: this.formData.idCardName,
          idcardNum: this.formData.idCardNum,
          dateOfIssue: this.formData.dateOfIssue.replace(/\./g, ''),
          dateOfInvalid: this.formData.dateOfInvalid.replace(/\./g, ''),
          idcardFrontUrl: this.renXiang.webUrl,
          idcardBackUrl: this.guoHui.webUrl,
          faceActiveUrl: this.renLian.webUrl,
          faceIdCardUrl: this.shouChi.webUrl,
        };
        wx.miniProgram.postMessage({ data });
        wx.miniProgram.redirectTo({
          url: '/pages/login/wakeup/wakeup',
        });
      } else {
        // 反之，则直接提交接口
        CusLoadingOpen();
        const data = {};
        // 当身份证和人脸都需要
        if (this.param.isNeedIdCard && this.param.isActive) {
          data.idcardName = this.formData.idCardName;
          data.idcardNum = this.formData.idCardNum;
          data.dateOfIssue = this.formData.dateOfIssue.replace(/\./g, '');
          data.dateOfInvalid = this.formData.dateOfInvalid.replace(/\./g, '');
          data.idcardFrontUrl = this.renXiang.webUrl;
          data.idcardBackUrl = this.guoHui.webUrl;
          data.faceActiveUrl = this.renLian.webUrl;
          data.faceIdCardUrl = this.shouChi.webUrl;
        }
        // 当只需要身份证，不需要人脸
        if (this.param.isNeedIdCard && !this.param.isActive) {
          data.idcardName = this.formData.idCardName;
          data.idcardNum = this.formData.idCardNum;
          data.dateOfIssue = this.formData.dateOfIssue.replace(/\./g, '');
          data.dateOfInvalid = this.formData.dateOfInvalid.replace(/\./g, '');
          data.idcardFrontUrl = this.renXiang.webUrl;
          data.idcardBackUrl = this.guoHui.webUrl;
        }
        // 当不需要身份证，只需要人脸
        if (!this.param.isNeedIdCard && this.param.isActive) {
          data.faceActiveUrl = this.renLian.webUrl;
          data.faceIdCardUrl = this.shouChi.webUrl;
        }
        SubmitSleepUserData(data)
          .then(res => {
            CusLoadingClose();
            SucceedHandle2(
              res.code,
              res.msg,
              () => {
                // 成功，给出提示信息
                CusAlert(res.msg, () => {
                  // 1.发送让小程序刷新状态的消息
                  wx.miniProgram.postMessage({ data: { page: 'wakeupRefresh' } });
                  // 2.跳转回小程序home页面
                  wx.miniProgram.switchTab({
                    url: '/pages/home/home',
                  });
                });
              },
              (code, msg) => {
                msg && CusToast(msg);
              }
            );
          })
          .catch(err => {
            CusLoadingClose();
            const msg = NotSucceedHandle(err.message);
            msg && CusToast(msg);
          });
      }
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      name === 'renLian' && (this[name].photoTips = PUBLIC_FACE_PHOTO_TIPS);
    },
    // 跳人脸识别
    jumpToLiveness() {
      let data = null;
      switch (this.param.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          data = this.createPostMessage('renLian');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          data = this.createPostMessage('ymt');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 拍照组件点击事件
    cameraImgClick(type) {
      switch (type) {
        case 'renXiang':
        case 'guoHui':
        case 'shouChi':
          const data = this.createPostMessage(type);
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 'renLian':
          this.jumpToLiveness();
          break;
      }
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'SleepWakeup',
        imgType: imgTypeStr,
        isNeedIdCard: this.param.isNeedIdCard,
        isActive: this.param.isActive,
        isMerPic: this.param.isMerPic,
        idCardBatchNo: this.param.idCardBatchNo,
        idCardName: this.formData.idCardName,
        idCardNum: this.formData.idCardNum,
        dateOfIssue: this.formData.dateOfIssue,
        dateOfInvalid: this.formData.dateOfInvalid,
        failMsg: this.formData.failMsg,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        rlWebUrl: encodeURIComponent(this.renLian.webUrl.replace('?', '|')),
        scWebUrl: encodeURIComponent(this.shouChi.webUrl.replace('?', '|')),
      };
    },
    // 调用接口识别身份证正面信息
    getIdCardFrontUrlV2() {
      CusLoadingOpen();
      GetIdCardFrontUrlV2({
        url: this.renXiang.webUrl,
        batchNo: this.param.idCardBatchNo,
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.formData.idCardName = res.data.Name;
              this.formData.idCardNum = res.data.IdCardNum;
              this.formData.address = res.data.Address;
              this.formData.familyName = res.data.FamilyName;
              this.formData.birthday = res.data.Birthday;
              this.formData.sex = res.data.Sex;
            },
            (code, msg) => {
              msg &&
                CusAlert(msg, () => {
                  this.resetCameraInfo('renXiang');
                });
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口识别身份证背面信息
    getIdCardBackUrlV2() {
      CusLoadingOpen();
      GetIdCardBackUrlV2({
        url: this.guoHui.webUrl,
        batchNo: this.param.idCardBatchNo,
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 现阶段此接口有BUG，未识别出背面时，code还是为0
              // 特用判断msg的方式补救一下
              if (res.msg !== '') {
                CusAlert(res.msg, () => {
                  this.resetCameraInfo('guoHui');
                });
              }
              this.formData.office = res.data.Office;
              this.formData.dateOfIssue = res.data.DateOfIssue;
              this.formData.dateOfInvalid = res.data.DateOfInvalid;
              this.formData.dateOf = `${res.data.DateOfIssue} - ${res.data.DateOfInvalid}`;
            },
            (code, msg) => {
              msg &&
                CusAlert(msg, () => {
                  this.resetCameraInfo('guoHui');
                });
            }
          );
        })
        .catch(() => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用云码通的接口做人脸识别
    yMTivingThing() {
      CusLoadingOpen();
      YMTivingThing({ url: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.renLian.webUrl = this.renLian.webUrl;
              this.renLian.fileUrl = this.renLian.webUrl;
              this.renLian.base64 = this.renLian.webUrl;
            },
            (code, msg) => {
              msg &&
                CusAlert(msg, () => {
                  this.renLian.webUrl = '';
                  this.renLian.fileUrl = '';
                  this.renLian.base64 = '';
                });
            }
          );
        })
        .catch(() => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.liu {
  .tips {
    line-height: 1;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;

    .txt {
      font-size: $title5;
      color: $explain-color;

      .red {
        color: red;
      }
    }
  }

  .id-card-style {
    width: 6rem;
    height: 4rem;
    vertical-align: middle;
    overflow: hidden;
    @include dynamic-color;

    .img {
      width: 100%;
      height: 100%;
    }
  }

  .id-card-tips {
    line-height: 1;
    padding-top: 0.2rem;
  }

  .form-item {
    line-height: 1;
    padding: 0.6rem 0;

    input[type='tel'] {
      width: 100%;
      font-size: $title3;
      outline: 0;
      padding: 0;
      border: 0;

      &:disabled {
        background-color: $highlight-color;
        color: $word-color;
      }

      &::-webkit-input-placeholder {
        color: $explain-color;
        font-size: $title3;
      }

      &:-moz-placeholder {
        color: $explain-color;
        font-size: $title3;
      }

      &::-moz-placeholder {
        color: $explain-color;
        font-size: $title3;
      }

      &:-ms-input-placeholder {
        color: $explain-color;
        font-size: $title3;
      }
    }

    .code {
      width: 6rem;
      text-align: right;
      padding-right: 0.75rem;
      @include dynamic-color;

      &.disabled {
        color: $explain-color !important;
      }
    }
  }

  .line {
    height: 1px;
    margin-left: 15px;
    border-bottom: 1px solid $border-color;
  }

  .mint-field {
    background-image: none;
  }

  .mint-field-core:disabled {
    background-color: $highlight-color;
  }
}
</style>
